import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

const ModalComponent = ({ show = false, children, onClose, titulo, width = "40vw" }) => {
  const [visible, setVisible] = useState(show);

  useEffect(() => {
    setVisible(show);
  }, [show]);

  const footer = (
    <div>
      <Button label="Cerrar" icon="pi pi-times" color='green' onClick={onClose} className="p-button-info" />
    </div>
  );

  return (
    <Dialog
      header={titulo}
      footer={footer}
      visible={visible}
      modal
      onHide={onClose}
      breakpoints={{ '960px': '75vw', '640px': '100vw' }}
      style={{ width: width, margin: '10px' }}
    >
      {children}
    </Dialog>
  );
};

export default ModalComponent